import { ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
} from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';

type BackBreadcrumbLinkProps = {
  label: string;
  path: string;
};
export const BackBreadcrumbLink = ({
  label,
  path,
}: BackBreadcrumbLinkProps) => {
  return (
    <Flex alignItems="center">
      <ChevronLeftIcon color={colors.gray[500]} />
      <Breadcrumb ml="8px" fontSize="xs" color={colors.gray[500]}>
        <BreadcrumbItem key={`${label}-${path}`}>
          <BreadcrumbLink as={Link} to={path}>
            {label}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
    </Flex>
  );
};
